<template>
  <v-row>
    <v-col cols="12">
      <gg-card-title class="pb-0 pt-0">
        Migrations List
      </gg-card-title>
    </v-col>
    <v-col cols="12">
      <migrations-list />
    </v-col>
  </v-row>
</template>

<script>
import MigrationsList from '@/components/Migrations/MigrationsList'

export default {
  name: 'MigrationsView',
  components: {
    MigrationsList,
  }
}
</script>
